import { INavigation } from '@/store/modules/userRoles/types';

export const initNavigationData: INavigation = {
  start: 0,
  elementsPerPage: 20,
  direction: 'forward',
  isLastElementsPage: false
};

export default initNavigationData;
